import { render, staticRenderFns } from "./datasource.vue?vue&type=template&id=1fe7bab4&scoped=true"
import script from "./datasource.vue?vue&type=script&lang=js"
export * from "./datasource.vue?vue&type=script&lang=js"
import style0 from "./datasource.vue?vue&type=style&index=0&id=1fe7bab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7bab4",
  null
  
)

export default component.exports